(() => {
  'use strict';

  const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
  const header = document.querySelector('[data-header]');
  const updateHeader = () => header?.classList.toggle('scrolled', window.scrollY > 12);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  // Only enable CSS hiding/animation after the script has loaded successfully.
  document.documentElement.classList.add('js');
  const revealItems = document.querySelectorAll('.reveal');
  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  const navToggle = document.querySelector('[data-nav-toggle]');
  const primaryNav = document.querySelector('[data-primary-nav]');
  const setMenuOpen = (open) => {
    navToggle?.setAttribute('aria-expanded', String(open));
    navToggle?.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    const glyph = navToggle?.querySelector('[aria-hidden="true"]');
    if (glyph) glyph.textContent = open ? '×' : '☰';
    primaryNav?.classList.toggle('is-open', open);
  };
  navToggle?.addEventListener('click', () => setMenuOpen(navToggle.getAttribute('aria-expanded') !== 'true'));
  primaryNav?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenuOpen(false)));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenuOpen(false); });
  document.addEventListener('click', (event) => {
    if (primaryNav?.classList.contains('is-open') && !primaryNav.contains(event.target) && !navToggle?.contains(event.target)) setMenuOpen(false);
  });

  document.querySelectorAll('[data-quantity-control]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    if (!input) return;
    control.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      input.value = String(Math.max(Number(input.min || 1), Number(input.value || 1) - 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    control.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      const next = Number(input.value || 1) + 1;
      input.value = String(input.max ? Math.min(Number(input.max), next) : next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = [...gallery.querySelectorAll('[data-media-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-media-thumb]')];
    const count = gallery.querySelector('[data-gallery-count]');
    if (!slides.length) return;
    const show = (requestedIndex) => {
      const index = Math.max(0, Math.min(slides.length - 1, Number(requestedIndex) || 0));
      slides.forEach((slide, i) => {
        slide.hidden = i !== index;
        slide.classList.toggle('is-active', i === index);
      });
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-selected', i === index ? 'true' : 'false');
        thumb.tabIndex = i === index ? 0 : -1;
      });
      if (count) count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
    show(0);
  });

  document.querySelectorAll('[data-product-shell]').forEach((shell) => {
    const select = shell.querySelector('select[data-variant-select]');
    const price = shell.querySelector('[data-product-price]');
    const compare = shell.querySelector('[data-product-compare]');
    const saving = shell.querySelector('[data-product-save]');
    const add = shell.querySelector('[data-add-to-cart]');
    if (!select || !price) return;
    const update = () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      price.textContent = option.dataset.price || price.textContent;
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      if (saving) {
        saving.textContent = option.dataset.save ? `Save ${option.dataset.save}` : '';
        saving.hidden = !option.dataset.save;
      }
      if (add) {
        add.disabled = option.disabled;
        const textNode = [...add.childNodes].find((node) => node.nodeType === Node.TEXT_NODE);
        if (textNode) textNode.textContent = option.disabled ? add.dataset.soldOutLabel : add.dataset.addLabel;
      }
    };
    select.addEventListener('change', update);
    update();
  });
})();
